<template lang="html">
  <div class="row">
    <div class="col-lg-6 lbv-device-data">
      <b-card header="Device Data">
        <!-- roleID:8 = External Operations, hide the status -->
        <b-table
          v-if="$store.getters.roleID === '8'"
          :items="deviceDataItems"
          :fields="deviceDataFieldsSimplified"
        />
        <b-table
          v-if="$store.getters.roleID !== '8'"
          :items="deviceDataItems"
          :fields="deviceDataFields"
        />
        <b-button
          class="page prev"
          variant="primary"
          size="sm"
          :disabled="pageNumber === 1"
          @click.prevent="page"
        >
          Prev
        </b-button>

        <b-button
          class="page next"
          variant="primary"
          size="sm"
          :disabled="!hasNextPage"
          @click.prevent="page"
        >
          Next
        </b-button>
        <div class="current-page">
          Page: {{ pageNumber }}
        </div>
      </b-card>
    </div>
    <WaterUsage
      :lb_id="lb_id"
      :device_id="device_id"
    />
  </div>
</template>

<script>
import { TabNavEvent } from '../../events/tabNavEvent'
import { APIEvent } from '../../events/apiEvent'
import { StatusBarEvent } from '../../events/statusBarEvent'
import { EventBus } from '../../event-bus'
import WaterUsage from './WaterUsage'

export default {
  name: 'DeviceDataView',
  components: {
    WaterUsage
  },
  props: ['lb_id', 'device_id'],
  data () {
    return {
      pageNumber: 1,
      hasNextPage: false,
      startOffset: 0,
      perPage: 10,
      deviceDataItems: [],
      deviceDataFields: [
        {
          key: 'messageType',
          label: 'Message Type',
          sortable: false,
          formatter: this.messageType
        },
        {
          key: 'messageTimestamp',
          label: 'Date',
          sortable: false
        }

      ],
      deviceDataFieldsSimplified: [
        {
          key: 'messageType',
          label: 'Message Type',
          sortable: false,
          formatter: this.messageType
        },
        {
          key: 'messageTimestamp',
          label: 'Date',
          sortable: false
        }

      ]
    }
  },
  mounted () {
    EventBus.$on(TabNavEvent.DEVICE_DATA, () => { this.init() })
  },
  destroyed () {
    EventBus.$off(TabNavEvent.DEVICE_DATA)
  },
  methods: {
    init () {
      this.pageNumber = 1
      this.startOffset = 0
      this.fetchDeviceData()
    },
    fetchDeviceData (offset, size) {
      var options = {
        id: this.lb_id,
        start_offset: offset || '0',
        fetch_size: size || '10'
      }
      this.$store.dispatch(APIEvent.FETCH_DEVICE_MESSAGES, options)
        .then((response) => {
          if (response.data.list !== '') {
            for (let i = 0; i < response.data.list.record.length; i++) {
              response.data.list.record[i].messageType = {}
              response.data.list.record[i].messageType.type = response.data.list.record[i].msg_type
              response.data.list.record[i].messageType.subtype = response.data.list.record[i].event_type
            }
          }
          this.deviceDataItems = response.data.list.record
          this.hasNextPage = response.data.LastPage === '0'
        })
        .catch(this.handleError)
    },
    page (event) {
      var next = event.currentTarget.className.indexOf('next') > -1
      if (next) {
        this.startOffset += this.perPage
        this.pageNumber += 1
      } else {
        this.startOffset -= this.perPage
        this.pageNumber -= 1
      }
      this.fetchDeviceData(this.startOffset.toString())
    },
    messageType: function (value) {
      var messages = ['Leak Test', 'Pipe Temp Log', 'Air Temp Log', 'Status Message', 'Unusual usage test', 'Wifi Temp Log', 'Sigfox Temp Log', 'Header Tank Cloud Leak Test', 'Vacant Property Tank Cloud Leak Test', 'Event Message', 'Log Message']
      if (value.type === '9' || value.subtype === 9) {
        let subtype = ['Reset message', 'Status message', 'Unusual usage test']
        this.messageType = subtype[value.subtype]
      } else {
        this.messageType = messages[value.type]
      }
      return this.messageType
    },
    handleError: function (error) {
      EventBus.$emit(StatusBarEvent.ERROR, error.message)
    }
  }
}
</script>

<style lang="css">
  .current-page{
    margin-top: -25px;
  }
</style>
